import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import NaplesAirportPage from "./pages/NaplesAirportPage";
import CookieConsent from "./components/CookieConsent";

// Italian routes
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/naples-airport-transfer" element={<NaplesAirportPage />} />
          <Route path="/transfer-aeroporto-napoli" element={<NaplesAirportPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <CookieConsent />
    </div>
  );
}

export default App;
